import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions, PostStatus } from './index';
import { PostEntity } from './list';

export type PostCreateData = { id: string };

export type PostCreateResponse = PostCreateData

export interface PostCreateBody {
  text?: string | null;
  text_org?: string | null;
  businessId?: string | null;
  categoryId?: string | null;
  subCategoryId?: string | null;
  articleId?: string | null;
  fileIds?: string[];
  status?: PostStatus;
  entity?: PostEntity,
}
export interface PostCreateParams {
  body: PostCreateBody;
  parentId?: string;
}

export const postCreate = (payload: PostCreateParams): Action<PostCreateParams> => ({
  type: actions.postCreateTrigger.toString(),
  payload,
});

export const postCreateClear = (): Action => ({
  type: actions.postCreateClear.toString(),
});

export const postCreateErrorClear = (): Action => ({
  type: actions.postCreateErrorReset?.toString(),
});

export function* postCreateRequestSaga({ payload }: Action<PostCreateBody>) {
  ({ payload });
  yield put({
    type: actions.postCreateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.postCreateError.toString(),
      payload: {
        message: 'PostCreate: Parameters not passed.',
      },
    });

    return;
  }

  const { body, parentId } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}posts${parentId ? `/${parentId}` : ''}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<PostCreateData, PostCreateResponse>(
    response,
    actions.postCreateSuccess.toString(),
    actions.postCreateError.toString(),
    false,
    (postCreateData) => postCreateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.postCreateTrigger.toString(),
    defaultProcessingSaga(
      postCreateRequestSaga,
      {
        error: actions.postCreateError.toString(),
        locationCancel: actions.postCreateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.postCreateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.postCreateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.postCreateErrorReset.toString(),
    });
  });
}
